import {Config, MockConfig} from '../../config/types';
import {Task, TaskQueryparameters} from './types';
import {mockDataGenerator as shiftMockDataGenerator} from '../shifts/mockDataGenerator';
import {getDatesInPeriod} from '../../utils';
import {generateFromTemplate, getInRange, numericIdFactory} from '../mocks';
import {Shift} from '../shifts';

let cache: {[key: string]: Task[]} = {};

type Template = {
  shiftPct: number;
  locId?: number | 'none';
  unassigned?: boolean;
};

const templates: {[count: number]: Template[][]} = {
  1: [
    [{shiftPct: 100}],
    [{shiftPct: 150}],
    [{shiftPct: 80}],
    [{shiftPct: 40, unassigned: true}],
  ],
  2: [
    // [{shiftPct: 40, locId: 2}, {shiftPct: 50, locId: 2}],
    [
      {shiftPct: 60, locId: 1},
      {shiftPct: 2, locId: 'none'},
      {shiftPct: 60, locId: 6},
    ],
    [
      {shiftPct: 35, locId: 2},
      {shiftPct: 10, locId: 2},
      {shiftPct: 5, locId: 'none'},
      {shiftPct: 40, locId: 6},
      {shiftPct: 10, locId: 'none'},
    ],
  ],
  3: [
    [{shiftPct: 30}, {shiftPct: 5, locId: 'none'}, {shiftPct: 40}],
    [{shiftPct: 25}, {shiftPct: 10, locId: 'none'}, {shiftPct: 50}],
    [{shiftPct: 60}, {shiftPct: 20}, {shiftPct: 20}],
  ],
};

const getLocationId = (template: Template): number =>
  template.locId === 'none'
    ? 0
    : typeof template.locId === 'number'
    ? template.locId
    : getInRange([0, 3]) * 3 + 1;

const generateTask = (
  teamId: number,
  date: string,
  shift: Shift,
  template: Template,
  index: number,
): Task => ({
  id: numericIdFactory(),
  teamId,
  shiftId: template.unassigned ? undefined : shift.id,
  externalId: '0',
  distrDate: date,
  vehicleTypeId: 0, // TODO
  name: 'TODO mock',
  durationMinutesEstimated: Math.floor(
    (shift.durationMinutes * template.shiftPct) / 100,
  ),
  // TODO: earliestStartPlanned: `${date}T${template.}`,
  // TODO: deadlineTimePlanned:
  hubId: getLocationId(template),
  taskSequence: (index + 1) * 1024,
});

export const generateTasks = (
  config: MockConfig,
  teamId: number,
  date: string,
  dependencies: {shifts: Shift[]},
): Task[] => {
  let result: Task[] = [];

  dependencies.shifts.forEach(shift => {
    const tasks = generateFromTemplate(
      templates,
      config.TaskCount,
      (template, index) => generateTask(teamId, date, shift, template, index),
    );
    result.push(...tasks);
  });

  return result;
};

export const mockDataGenerator = (config: Config) => ({
  teamId,
  fromDate,
  toDate,
}: TaskQueryparameters): Task[] => {
  const dates = getDatesInPeriod(fromDate, toDate);
  let result: Task[] = [];

  dates.forEach(d => {
    const key = `${teamId}:${d}`;
    if (!cache[key]) {
      const shifts = shiftMockDataGenerator(config)({
        teamId,
        fromDate: d,
        toDate: d,
      });

      cache[key] = generateTasks(config.Api.Mock, teamId, d, {shifts});
    }

    result.push(...cache[key]);
  });

  return result;
};
